// src/utils/idempotencyKey.js
//
// A fresh key per write attempt. Kept separate from the transport module so it
// can be imported (and tested) without pulling in the API layer and the Redux
// store behind it.
//
// `crypto.randomUUID` is unavailable on insecure origins and older Safari, so
// fall back to getRandomValues and finally to a time+random string. A retried
// attempt must never reuse the previous key — that is the whole point.
export default function newIdempotencyKey() {
  const cryptoObj = typeof window !== 'undefined' ? window.crypto : undefined;
  if (typeof cryptoObj?.randomUUID === 'function') return cryptoObj.randomUUID();
  if (typeof cryptoObj?.getRandomValues === 'function') {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
